export const signUpSchema = () => ({
  loginEmail: { required: true, email: true, label: "email address" },
  loginPassword: { required: true, label: "password" },
  captcha: { required: true, reCaptcha: true, label: "captcha" }
});

export const forgotPasswordSchema = () => ({
  emailAddress: { required: true, email: true, label: "email address" },
  captcha: { required: true, reCaptcha: true, label: "captcha" }
});

export const recoverPasswordSchema = () => ({
  emailAddress: { required: true, email: true, label: "email address" },
  captcha: { required: true, reCaptcha: true, label: "captcha" }
});

export const registerSchema = () => ({
  firstName: { required: true, label: "first name" },
  lastName: { required: true, label: "last name" },
  emailAddress: { required: true, email: true, label: "email address" },
  reEnterEmailAddress: {
    required: true,
    compare: { key: "emailAddress" },
    email: true,
    label: "Email address"
  },
  password: { required: true, label: "password", min: 7 },
  confirmPassword: {
    required: true,
    compare: { key: "password" },
    label: "Password"
  },
  captcha: { required: true, reCaptcha: true, label: "captcha" }
});

export const subscribeSchema = () => ({
  emailAddress: { required: true, email: true, label: "email address" }
});

export const feedbackSchema = () => ({
  category: {
    required: true,
    label: "category"
  },
  comment: { required: true, label: "comment" },
  email: { required: true, email: true, label: "email address" },
  captcha: { required: true, reCaptcha: true, label: "captcha" }
});

export const contactUsSchema = () => ({
  fullName: { required: true, label: "fullName" },
  userEmail: { required: true, email: true, label: "userEmail" },
  department: {
    required: true,
    department: true,
    label: "department"
  },
  orderPartNumber: { required: true, label: "orderPartNumber" },
  message: { required: true, label: "message" },
  captcha: { required: true, reCaptcha: true, label: "captcha" }
});

export const policySchema = () => ({
  pInfoOurNumber: { required: true, label: "part number" },
  pInfoCompNumber: { required: true, label: "competitor's part number" },
  pInfoCompPrice: { required: true, label: "competitor's price" },
  pInfoCompShippingCharge: {
    required: true,
    label: "competitor shipping charge"
  },
  cInfoCompanyName: { required: true, label: "company name" },
  cInfoWebUrl: { required: true, label: "website url" },
  cInfoCompanyAddr: { required: true, label: "company address" },
  cInfoPhoneNumber: { required: true, phone: true, label: "phone number" },
  infoCustomerName: { required: true, label: "name" },
  infoEmail: { required: true, email: true, label: "email" },
  infoAddress: { required: true, label: "address" },
  infoPhoneNumber: { required: true, phone: true, label: "phone number" },
  captcha: { required: true, reCaptcha: true, label: "captcha" }
});

export const rmaSchema = formData => ({
  customerName: { required: true, label: "customer name" },
  customerEmail: {
    required: true,
    email: true,
    label: "customer email"
  },
  customerNumber: { required: false },
  orderNumber: {
    required: true,
    ordernumber: true,
    label: "order number"
  },
  orderPartNumber: {
    required: true,
    orderpartnumber: true,
    label: "part number"
  },
  orderPartName: { required: false },
  returnType: {
    required: true,
    label: "return type"
  },
  shippingBox: {
    required: formData.returnType === "Damaged",
    shippingbox: true,
    label: "box info"
  },
  offerType: {
    required: formData.returnType === "Defective",
    offertype: true,
    label: "offer type"
  },
  description: {
    required: !(
      formData.returnType === "Incomplete Shipment/Missing Parts" ||
      formData.returnType === "Core"
    ),
    label: "description"
  },
  make: {
    required: !(
      formData.returnType === "No Longer Needed" ||
      formData.returnType === "Wrong Part Ordered" ||
      formData.returnType === "Incomplete Shipment/Missing Parts" ||
      formData.returnType === "Core" ||
      formData.returnType === "Defective"
    ),
    make: true,
    label: "make"
  },
  model: {
    required: !(
      formData.returnType === "No Longer Needed" ||
      formData.returnType === "Wrong Part Ordered" ||
      formData.returnType === "Incomplete Shipment/Missing Parts" ||
      formData.returnType === "Core" ||
      formData.returnType === "Defective"
    ),
    model: true,
    label: "model"
  },
  year: {
    required: !(
      formData.returnType === "No Longer Needed" ||
      formData.returnType === "Wrong Part Ordered" ||
      formData.returnType === "Incomplete Shipment/Missing Parts" ||
      formData.returnType === "Core" ||
      formData.returnType === "Defective"
    ),
    year: true,
    label: "year"
  },
  captcha: { required: true, reCaptcha: true, label: "captcha" }
});

export const trackOrderSchema = () => ({
  email: { required: true, email: true, label: "email address" },
  order: { required: true, label: "order" }
});

export const retriveQuoteSchema = () => ({
  quoteNumber: { required: true, label: "quote id" }
});

export const saveQuoteSchema = () => ({
  firstName: { required: true, label: "first name" },
  lastName: { required: true, label: "last name" },
  email: { required: true, email: true, label: "email address" },
  phoneNumber: { required: true, phone: true, label: "phone number" }
});

export const resetPasswordSchema = () => ({
  loginPassword: { required: true, label: "new password" },
  loginNewPassword: {
    required: true,
    compare: { key: "loginPassword" },
    label: "Password"
  },
  captcha: { required: true, reCaptcha: true, label: "captcha" }
});

export const addAddressSchema = formData => ({
  label: { required: true, label: "label" },
  firstName: { required: true, label: "first name", max: 30 },
  lastName: { required: true, label: "last name", max: 30 },
  country: {
    dropRequire: formData.country === "Select Country",
    label: "country"
  },
  addressLine1: {
    required: true,
    label: "street address",
    max: 30
  },
  addressLine2: { label: "Apt, suite, etc", max: 30 },
  city: { required: true, label: "city" },
  state: {
    dropRequire: formData.state === "Select State",
    label: "state"
  },
  zipcode: { required: true, label: "zip code" },
  phoneNumber: {
    required: true,
    phone: true,
    label: "phone number"
  }
});

export const addPaymentSchema = () => ({
  cardLabel: { required: true, label: "card label" },
  cardName: { required: true, label: "card name" }
});

export const customerSchema = {
  customerFirstName: {
    required: true,
    label: "First Name",
    max: 30
  },
  customerLastName: {
    required: true,
    label: "Last Name",
    max: 30
  },
  customerStreetAddress: {
    required: true,
    label: "Street Address",
    max: 30,
    poBox: true
  },
  customerSuburbAddress: { label: "Apt, suite, etc", max: 30 },
  customerCity: { required: true, label: "City" },
  customerPostcode: {
    required: true,
    zipcode: true,
    label: "ZIP Code"
  },
  customerState: { required: true, label: "State" },
  customerCountry: { required: true, label: "Country" },
  customerTelephone: {
    required: true,
    phone: true,
    label: "Phone Number"
  }
};

export const shipmentSchema = {
  shippingMethod: { required: true },
  deliveryFirstName: {
    required: true,
    label: "First Name",
    max: 30
  },
  deliveryLastName: {
    required: true,
    label: "Last Name",
    max: 30
  },
  deliveryStreetAddress: {
    required: true,
    label: "Street Address",
    max: 30,
    poBox: true
  },
  deliverySuburbAddress: {
    label: "Apt, suite, etc",
    max: 30
  },
  deliveryCity: { required: true, label: "City" },
  deliveryPostcode: {
    required: true,
    zipcode: true,
    label: "ZIP Code"
  },
  deliveryState: { required: true, label: "State" },
  deliveryCountry: { required: true, label: "Country" },
  deliveryTelephone: {
    required: true,
    phone: true,
    label: "Phone Number"
  },
  deliveryEmailAddress: {
    required: true,
    email: true,
    label: "Email Address"
  },
  deliveryVerifyEmailAddress: {
    compare: { key: "deliveryEmailAddress" },
    email: true,
    label: "Email Address"
  }
};

export const customerSchemaBeta = {
  customerFirstName: {
    required: true,
    label: "First Name",
    maxCounter: 30
  },
  customerLastName: {
    required: true,
    label: "Last Name",
    maxCounter: 30
  },
  customerStreetAddress: {
    required: true,
    label: "Street Address",
    maxCounterNewLine: 30
  },
  customerSuburbAddress: { label: "Apt, suite, etc", maxCounter: 30 },
  customerCity: { required: true, label: "City" },
  customerPostcode: {
    required: true,
    zipcode: true,
    label: "ZIP Code"
  },
  customerState: { required: true, label: "State" },
  customerCountry: { required: true, label: "Country" },
  customerTelephone: {
    required: true,
    phone: true,
    label: "Phone Number"
  }
};

export const shipmentSchemaBeta = {
  shippingMethod: { required: true },
  deliveryFirstName: {
    required: true,
    label: "First Name",
    maxCounter: 30
  },
  deliveryLastName: {
    required: true,
    label: "Last Name",
    maxCounter: 30
  },
  deliveryStreetAddress: {
    required: true,
    label: "Street Address",
    maxCounterNewLine: 30,
    poBox: true
  },
  deliverySuburbAddress: {
    label: "Apt, suite, etc",
    maxCounter: 30
  },
  deliveryCity: { required: true, label: "City" },
  deliveryPostcode: {
    required: true,
    zipcode: true,
    label: "ZIP Code"
  },
  deliveryState: { required: true, label: "State" },
  deliveryCountry: { required: true, label: "Country" },
  deliveryTelephone: {
    required: true,
    phone: true,
    label: "Phone Number"
  },
  deliveryEmailAddress: {
    required: true,
    email: true,
    label: "Email Address"
  }
};

export const shipmentSchemaBetaV2 = {
  deliveryFirstName: {
    required: true,
    label: "First Name",
    maxCounter: 30
  },
  deliveryLastName: {
    required: true,
    label: "Last Name",
    maxCounter: 30
  },
  deliveryStreetAddress: {
    required: true,
    label: "Street Address",
    maxCounterNewLine: 30,
    poBox: true
  },
  deliverySuburbAddress: {
    label: "Apt, suite, etc",
    maxCounter: 30
  },
  deliveryCity: { required: true, label: "City" },
  deliveryPostcode: {
    required: true,
    zipcode: true,
    label: "ZIP Code"
  },
  deliveryState: { required: true, label: "State" },
  deliveryCountry: { required: true, label: "Country" },
  deliveryTelephone: {
    required: true,
    phone: true,
    label: "Phone Number"
  },
  deliveryEmailAddress: {
    required: true,
    email: true,
    label: "Email Address"
  }
}

export const signInSchema = {
  loginEmail: { required: true, email: true, label: "email address" },
  loginPassword: { required: true, label: "password" },
  captcha: { required: true, reCaptcha: true, label: "captcha" }
};

export const signInSchemaV2 = {
  loginEmail: { required: true, email: true, label: "email address" },
  loginPassword: { required: true, label: "password" },
};

export const loginDetailsSchema = () => ({
  firstName: { required: true, label: "first name" },
  lastName: { required: true, label: "last name" },
  emailAddress: { required: true, email: true, label: "email address" },
  oldPassword: { required: true, label: "current password" },
  newPassword: { required: true, label: "new password" },
  confirmPassword: {
    required: true,
    compare: { key: "newPassword" },
    message: "Your new password does not match with your confirmation password"
  }
});

export const notifySchema = () => ({
  emailAddress: { required: true, email: true, label: "email address" },
  emailFromCarpats: { label: "email from carparts" },
  captcha: { required: true, reCaptcha: true, label: "captcha" }
});

export const shippingSavedAddressSchema = {
  deliveryStreetAddress: {
    required: true,
    label: "Street Address",
    max: 30,
    poBox: true
  }
};

export const billingSavedAddressSchema = {
  customerStreetAddress: {
    required: true,
    label: "Street Address",
    max: 30
  }
};

export const shippingSavedAddressSchemaBeta = {
  deliveryStreetAddress: {
    required: true,
    label: "Street Address",
    max: 30,
    poBox: true
  }
};

export const billingSavedAddressSchemaBeta = {
  customerStreetAddress: {
    required: true,
    label: "Street Address",
    max: 30
  }
};
